import { BareActionContext } from 'vuex-typex'
import { AuthState } from '../state'
import { RootState } from '../..'
import authStore from '../auth-store'
import authUtils from './auth-utils'

export default async function logout(context: BareActionContext<AuthState, RootState>)
{
    authUtils.authService.logout().then((result: any) => {
        authStore.commitSetNotAuthenticated()
    })

    return
}
